// This published URL can move to environment/configuration when the inventory source needs to vary by environment.
export const BINDER_BUILDERS_INVENTORY_CSV_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vSZn_ekrtYPtW9S8OmpSaWMHbW3JTOKqUUHTgu12b3dCUS9jfajy0g5X1eRp_2yY0brHXkTZDuyohKk/pub?gid=1586221566&single=true&output=csv";

const REQUIRED_COLUMNS = ["productSlug", "name", "description", "quantity", "active"];

function parseCsv(csvText) {
  const rows = [];
  let row = [];
  let value = "";
  let inQuotes = false;

  for (let index = 0; index < csvText.length; index += 1) {
    const character = csvText[index];

    if (inQuotes) {
      if (character === '"') {
        if (csvText[index + 1] === '"') {
          value += '"';
          index += 1;
        } else {
          inQuotes = false;
        }
      } else {
        value += character;
      }
      continue;
    }

    if (character === '"') {
      inQuotes = true;
    } else if (character === ",") {
      row.push(value);
      value = "";
    } else if (character === "\n" || character === "\r") {
      if (character === "\r" && csvText[index + 1] === "\n") {
        index += 1;
      }
      row.push(value);
      rows.push(row);
      row = [];
      value = "";
    } else {
      value += character;
    }
  }

  if (inQuotes) {
    throw new Error("Inventory CSV has an unclosed quoted value.");
  }

  if (row.length > 0 || value) {
    row.push(value);
    rows.push(row);
  }

  return rows;
}

function isActive(value) {
  return ["true", "yes", "1"].includes(String(value).trim().toLowerCase());
}

function getRowValue(row, columnIndexes, columnName) {
  return String(row[columnIndexes[columnName]] || "").trim();
}

export async function fetchBinderBuildersInventory() {
  const response = await fetch(BINDER_BUILDERS_INVENTORY_CSV_URL);

  if (!response.ok) {
    throw new Error("Unable to load live inventory.");
  }

  const rows = parseCsv(await response.text());
  const [headerRow, ...dataRows] = rows;
  const headers = (headerRow || []).map((header) => header.replace(/^\uFEFF/, "").trim());
  const columnIndexes = Object.fromEntries(headers.map((header, index) => [header, index]));

  if (REQUIRED_COLUMNS.some((column) => columnIndexes[column] === undefined)) {
    throw new Error("Inventory CSV is missing required columns.");
  }

  return dataRows.reduce((inventoryByProduct, row) => {
    const productSlug = getRowValue(row, columnIndexes, "productSlug");
    const name = getRowValue(row, columnIndexes, "name");

    if (!isActive(getRowValue(row, columnIndexes, "active")) || !productSlug || !name) {
      return inventoryByProduct;
    }

    const quantity = Number(getRowValue(row, columnIndexes, "quantity"));
    if (!Number.isFinite(quantity)) {
      return inventoryByProduct;
    }

    const inventoryItem = {
      productSlug,
      name,
      description: getRowValue(row, columnIndexes, "description"),
      quantity,
      active: true,
    };

    if (!inventoryByProduct[productSlug]) {
      inventoryByProduct[productSlug] = [];
    }

    inventoryByProduct[productSlug].push(inventoryItem);
    return inventoryByProduct;
  }, {});
}
